import React from 'react';

export type TrustedByVariant = 'trust-line' | 'categories' | 'combined' | 'compact';

interface TrustedByProps {
  /** 'trust-line' = Option 1 only (subtle text). 'categories' = Option 2 (heading + list). 'combined' = both. 'compact' = short trust line for tight spaces (e.g. Contact). */
  variant?: TrustedByVariant;
  /** Optional class for layout-specific overrides */
  className?: string;
}

const trustLineCopy = 'Trusted by organisations across London, Wimbledon and Surrey.';
const categoriesHeading = 'Who we work with';
const categories = [
  { label: 'Global law firms', icon: 'fas fa-balance-scale' },
  { label: 'CEOs, Partners, and Senior Executives', icon: 'fas fa-chart-line' },
  { label: 'FTSE 100 executives', icon: 'fas fa-user-tie' },
  { label: 'Healthcare and professional services', icon: 'fas fa-stethoscope' },
];
const compactCopy = 'Trusted by partners, CEOs and senior executives at leading firms across London.';
const stat = { value: '10+', label: 'years of expertise' };

const TrustedBy: React.FC<TrustedByProps> = ({ variant = 'combined', className = '' }) => {
  if (variant === 'compact') {
    return (
      <div className={`trusted-by trusted-by--compact ${className}`.trim()}>
        <div className="container">
          <p className="trusted-by-trust-line">{compactCopy}</p>
        </div>
      </div>
    );
  }

  if (variant === 'trust-line') {
    return (
      <div className={`trusted-by trusted-by--trust-line ${className}`.trim()}>
        <div className="container">
          <div className="trusted-by-divider" aria-hidden="true" />
          <p className="trusted-by-trust-line">{trustLineCopy}</p>
        </div>
      </div>
    );
  }

  if (variant === 'categories') {
    return (
      <div className={`trusted-by trusted-by--categories ${className}`.trim()}>
        <div className="container">
          <h2 className="trusted-by-heading">{categoriesHeading}</h2>
          <div className="trusted-by-divider" aria-hidden="true" />
          <div className="trusted-by-grid">
            {categories.map((item, i) => (
              <div key={i} className="trusted-by-card">
                <span className="trusted-by-card-icon" aria-hidden="true">
                  <i className={item.icon} />
                </span>
                <span className="trusted-by-card-label">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // combined
  return (
    <div className={`trusted-by trusted-by--combined ${className}`.trim()}>
      <div className="container">
        <p className="trusted-by-trust-line">{trustLineCopy}</p>
        <div className="trusted-by-stat-wrapper">
          <div className="trusted-by-stat">
            <span className="trusted-by-stat-value">{stat.value}</span>
            <span className="trusted-by-stat-label">{stat.label}</span>
          </div>
        </div>
        <h2 className="trusted-by-heading">{categoriesHeading}</h2>
        <div className="trusted-by-divider" aria-hidden="true" />
        <div className="trusted-by-grid">
          {categories.map((item, i) => (
            <div key={i} className="trusted-by-card">
              <span className="trusted-by-card-icon" aria-hidden="true">
                <i className={item.icon} />
              </span>
              <span className="trusted-by-card-label">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustedBy;
